// extracted by mini-css-extract-plugin
export default {"freeSpinTooltip":"SpinIndicator_freeSpinTooltip__IpjRi","text":"SpinIndicator_text__xlQum"};